import React from 'react';
import { useIntl } from 'react-intl-next';
import { Box, Inline, Text } from '@atlaskit/primitives';
import { RovoLogo } from '@atlassian/conversation-assistant-ui-components';
import messages from './messages';

// TODO: Remove during platform_editor_ai_command_palette_post_ga cleanup
export var PoweredByRovo = function PoweredByRovo() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(Inline, {
    space: "space.025"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, formatMessage(messages.agentsFooterRightText))), /*#__PURE__*/React.createElement(RovoLogo, {
    label: formatMessage(messages.agentsFooterRightText)
  }));
};